var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.399,
    height: 47.404,
    viewBox: "0 0 47.399 47.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Close",
    d: "M5.321.721,5.63.993,22.985,18.346,40.341.993A3.279,3.279,0,0,1,45.26,5.322l-.272.308L27.625,22.986,44.978,40.341a3.279,3.279,0,0,1-4.328,4.918l-.308-.272L22.985,27.625,5.63,44.978A3.279,3.279,0,0,1,.711,40.65l.272-.308L18.346,22.986.993,5.63A3.279,3.279,0,0,1,5.321.721Z",
    transform: "translate(0.711 0.716)",
    fill: "#4a4a4a",
    stroke: "#4a4a4a",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9fb9e5a4d40a3b0ab36ec6d33890c42c.svg";
export { ForwardRef as ReactComponent };